<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <input type="text"
           class="form-control"
           :class="errorMessage ? 'is-invalid' : ''"
           list="buildings"
           autocomplete="on"
           :minlength="minlength"
           :placeholder="placeholder"
           v-model="searchBuildingName"
           @change="doSelect($event)"
    >
    <datalist id="buildings">
      <option v-for="buildingSearchResult in buildingSearchResults"
              :key="buildingSearchResult.id"
              :value="buildingSearchResult.name"
      >
        {{ buildingSearchResult.name }}
      </option>
    </datalist>
    <div class="invalid-feedback">{{ errorMessage }}</div>
    <span v-if="warningMessage" class="form-text text-secondary">{{ warningMessage }}</span>
  </form-layout>
</template>

<script>
import BaseVuexFormItem from "@/views/molecules/formItems/BaseVuexFormItem";
import FormLayout from "@/views/templates/FormLayout";

export default {
  name: "VuexBuildingTextFormItem",
  extends: BaseVuexFormItem,
  components: {
    FormLayout,
  },
  props: {
    label: {
      type: String,
      default: '依頼物件選択'
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    minlength: {
      type: [Number, null],
      default: null
    },
    placeholder: {
      type: String,
      required: true
    },
    searchType: {
      type: Number,
      required: true
    },
  },
  emits: ['select'],
  data() {
    return{
      searchBuildingName: null,
      buildingSearchResults: [],
    }
  },
  computed : {
    warningMessage() {
      if (!!this.searchBuildingName && this.value === null) {
        return '入力された依頼物件が存在しません。';
      }
      return null;
    },
  },
  watch: {
    searchBuildingName(newSearchBuildingName) {
      if (newSearchBuildingName.length >= this.minlength && this.searchType === 1) {
        this.buildingSearchResults = this.options.filter(
          building => building.name.indexOf(newSearchBuildingName) > -1
        );
      } else if(newSearchBuildingName.length >= this.minlength && this.searchType === 2) {
        this.buildingSearchResults = this.options.filter(
          building => building.name.indexOf(newSearchBuildingName) === 0
        );
      } else {
        this.buildingSearchResults = this.options.filter(
          building => building.name === newSearchBuildingName
        );
      }
    }
  },
  mounted() {
    if (this.value) {
      const filtered = this.options.filter(building => building.id === this.value);
      this.searchBuildingName = filtered.length > 0 ? filtered[0].name : null;
    }
  },
  methods: {
    doSelect(event) {
      this.searchBuildingName = event.target.value;
      const filtered = this.options.filter(building => building.name === event.target.value);
      this.value = filtered.length > 0 ? filtered[0].id : null;
      this.$emit('select', this.value);
    },
  },
}
</script>